import React from "react";
import GoogleTrafficMap from "./GoogleTrafficMap";

function App() {
  return (
    <div>
      <GoogleTrafficMap 
  deviceLat={13.0827} 
  deviceLng={80.2707} 
  userLat={11.9200} 
  userLng={79.8200} 
/>
    </div>
  );
}

export default App;
